import React, { useEffect, useState } from "react";

export const GestionSelect = ({ name, value, onChange }) => {
  const [state, setState] = useState([]);

  return (
    <select
      className="select-gestion"
      name={name}
      value={value}
      onChange={onChange}
    >
      <option value="C">Total de Cartera</option>
      <option value="R">Recuperado</option>
      <option value="G">Gestionado</option>
      <option value="V">Conveniado</option>
      <option value="S">Sin Gestion</option>
      {state.map((item) => (
        <option key={`cartera-${item.value}`} value={item.value}>
          {item.linea}
        </option>
      ))}
    </select>
  );
};